import React from 'react'
import { __ } from "@wordpress/i18n";
import FeatureWidgetsOnboarding from '@components/Widgets/Features/FeatureWidgetsOnboarding';

const Configure = ({ setCurrentStep, markStepCompleted, markStepSkipped }) => {
    return (
        <FeatureWidgetsOnboarding setCurrentStep={setCurrentStep} markStepCompleted={markStepCompleted} markStepSkipped={markStepSkipped} />
    )
}

export default Configure
